import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-view" }
const _hoisted_2 = { class: "login-content" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "login-error"
}

import { ref } from "vue";
import { useAuth } from "@/composables/useAuth";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const { login } = useAuth();
const isLoggingIn = ref(false);
const loginError = ref<string | null>(null);

const handleLogin = async () => {
  isLoggingIn.value = true;
  loginError.value = null;
  
  try {
    await login();
  } catch (error) {
    loginError.value = error instanceof Error ? error.message : "Login failed";
  } finally {
    isLoggingIn.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo-placeholder" }, null, -1)),
      _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Welcome!", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "Please sign in to continue.", -1)),
      _createElementVNode("button", {
        onClick: handleLogin,
        disabled: isLoggingIn.value
      }, _toDisplayString(isLoggingIn.value ? 'Signing in...' : 'Sign In'), 9, _hoisted_3),
      (loginError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(loginError.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})